document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-swc-product]').forEach((root) => {
    const mainImage = root.querySelector('.swc-product__main-media img');
    root.querySelectorAll('[data-swc-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.imageSrc;
      mainImage.srcset = '';
      mainImage.alt = thumb.dataset.imageAlt || '';
      root.querySelectorAll('[data-swc-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }));
    const quantity = root.querySelector('[data-swc-qty] input');
    root.querySelector('[data-swc-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    root.querySelector('[data-swc-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    const variant = root.querySelector('[data-swc-variant]');
    variant?.addEventListener('change', () => { const selected = variant.options[variant.selectedIndex]; const price = root.querySelector('[data-swc-price]'); if (price && selected.dataset.price) price.textContent = selected.dataset.price; });
  });
});
